import { Component, OnInit,ViewChild} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { PredialService } from "../../servicios/servicio.index";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalDirective } from "ngx-bootstrap";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-consulta-saldo',
  templateUrl: './consulta-saldo.component.html',
  styleUrls: ['./consulta-saldo.component.css']
})
export class ConsultaSaldoComponent implements OnInit {

 
  imagenes: any[] = [];
  loading = true;
  fecha = new Date();
  mensaje: string = "";
  master: any = {
    ClaveCatastral: "",
    fecha_limite: "",
    BimestreInicial: "",
    ImporteTotal: "",
    nombre: "",
    NombrePropietario: ""
  };
  forma: any = { ...this.master};

  modalRef!: BsModalRef;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private _predialService: PredialService,
  //  private modalService: NgbModal
    private modalService: BsModalService
  ) {


    const navigation: any = this.router.getCurrentNavigation();
    const clave_catastral = navigation.extras.state
      ? navigation.extras.state.clave_catastral
      : 0;

    if (clave_catastral > 0) {
      this.getImagenes();
      this.buscar(clave_catastral);
    } else {
      this.loading = false;
      this.router.navigate([
        "/predial"]);
    }



    /* this.route.params.subscribe(parametros => {
      this.loading = true;
      const clave_catastral = parametros["clave_catastral"];

      if (clave_catastral > 0) {
        this.wowService.init();
        this.getImagenes();
        this.buscar(clave_catastral);
      } else {
        this.loading = false;
      }
    });*/
  }

  ngOnInit() {
    this.getImagenes();
  }

  getImagenes() {
    this._predialService.getImagenes().subscribe(
      data => {
        console.log(data.registros)
        this.imagenes = data.registros;
      },
      err => { }
    );
  }

  ngOnDestroy() {
  }

  buscar(clave_catastral: any) {
    console.log(clave_catastral)
    this._predialService.getConsulta(clave_catastral).subscribe(
      data => {
        this.forma = data.registro;
      },
      err => { }
    );
  }

  validar(template:any) {
    console.log(this.forma.nombre)
    console.log(this.forma.NombrePropietario)
    this.forma.NombrePropietario = this.forma.NombrePropietario.replace(
      /\s\s+/,
      ""
    );
    this.forma.nombre = this.forma.nombre.replace(
      /\s\s+/,
      ""
    );

    if (this.forma.nombre == this.forma.NombrePropietario) {
      /*this.router.navigate([
          "/predial/desglose_saldo",
          this.forma.ClaveCatastral
        ]);*/
        this.modalService.hide(template)
      this.router.navigateByUrl("/desglose_saldo", {
        state: { clave_catastral: this.forma.ClaveCatastral }
      });
     // this.modalService.hide(template)
    } else {
      this.mensaje = "¡El NOMBRE no coincide con su clave catastral!";
    }
  }

  enviar(m:any) {
    m.show();
    //this.modalRef = this.modalService.show(template);
  }
}